import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  DialogActions,
  Button,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { t } from "i18next";
import React from "react";
import { OverviewGoalProgress } from "./OverviewGoalProgress";

interface IInformationModal {
  onClose(): any;
  open: boolean;
}

const useStyles = makeStyles({
  root: {
    padding: "15px 13px",
    textAlign: "left",
  },
  title: {
    overflow: "visible",
  },
  heading: {
    padding: "0 13px",
  },
});

export const OverviewInformationModal = ({
  onClose,
  open,
}: IInformationModal) => {
  const classes = useStyles();
  return (
    <Dialog onClose={onClose} open={open} fullWidth={true} maxWidth={"sm"}>
      <DialogContent
        classes={{
          root: classes.title,
        }}
      >
        <DialogTitle>{t("Information")}</DialogTitle>
      </DialogContent>
      <DialogContent
        classes={{
          root: classes.root,
        }}
      >
        <Typography
          classes={{
            root: classes.heading,
          }}
          variant="h3"
        >
          {t("Cost")}
        </Typography>
        <Typography
          variant="body2"
          classes={{
            root: classes.root,
          }}
        >
          {t(
            "The cost is calculated by adding up all the meters individual cost for the current month"
          )}
        </Typography>
        <Typography
          classes={{
            root: classes.heading,
          }}
          variant="h3"
        >
          {t("CO2e")}
        </Typography>
        <Typography
          variant="body2"
          classes={{
            root: classes.root,
          }}
        >
          {t(
            "The carbon footprint is calculated by adding up all the meters individual emission for the current month"
          )}
        </Typography>
        <Typography
          classes={{
            root: classes.heading,
          }}
          variant="h3"
        >
          {t("Progress bar")}
        </Typography>

        <Typography
          variant="body2"
          classes={{
            root: classes.root,
          }}
        >
          {t(
            "The progress bar shows the total consumption in its respective unit that goes towards a prognosis for the entire month. The prognosis is calculated by multiplying the current months daily average with the amount of days left in the month. On the first two days of the month the prognosis is instead the last months consumption"
          )}
        </Typography>
        <Box width={"70%"} margin={"0 15px"}>
          <OverviewGoalProgress
            currentValue={30}
            goalValue={100}
            unit={"kwh"}
            util={"Electric"}
          />
        </Box>
      </DialogContent>
      <Box>
        <DialogActions>
          <Button size="large" onClick={onClose} color="primary" variant="text">
            {t("Close")}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
